import React from 'react';

const QuoteSection = () => (
  <section className="relative py-28 md:py-36 bg-cover bg-center bg-fixed"
    style={{ backgroundImage: 'linear-gradient(rgba(15,21,40,0.7), rgba(15,21,40,0.7)), url(https://images.pexels.com/photos/35250404/pexels-photo-35250404.jpeg?auto=compress&cs=tinysrgb&w=1920)' }}>
    <div className="max-w-4xl mx-auto px-6 text-center text-white">
      <h2 className="heading-display text-3xl md:text-5xl lg:text-6xl font-bold leading-[1.2]">
        &ldquo;The roots of education are bitter, <br className="hidden md:block" /> but the fruit is sweet.&rdquo;
      </h2>
      <p className="mt-8 heading-display text-3xl md:text-4xl text-[#F97559] underline decoration-2 underline-offset-8">- Aristotle</p>
    </div>
  </section>
);

export default QuoteSection;
